import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import { ContentProvider } from './context/ContentContext'
import ProtectedRoute from './components/ProtectedRoute'

// Public Pages
import HomePage from './pages/HomePage'
import AboutPage from './pages/AboutPage'
import ProgramsPage from './pages/ProgramsPage'
import ProgramDetailPage from './pages/ProgramDetailPage'
import EventsPage from './pages/EventsPage'
import BoardPage from './pages/BoardPage'
import BlogPage from './pages/BlogPage'
import BlogPostDetailPage from './pages/BlogPostDetailPage'
import VolunteerPage from './pages/VolunteerPage'
import ContactPage from './pages/ContactPage'
import DonatePage from './pages/DonatePage'

// Admin Pages
import LoginPage from './pages/admin/LoginPage'
import AdminDashboard from './pages/admin/AdminDashboard'
import ContentManager from './pages/admin/ContentManager'
import BoardManager from './pages/admin/BoardManager'
import ProgramManager from './pages/admin/ProgramManager'
import EventManager from './pages/admin/EventManager'
import BlogManager from './pages/admin/BlogManager'
import VolunteerApplicationsManager from './pages/admin/VolunteerApplicationsManager'
import ContactSubmissionsManager from './pages/admin/ContactSubmissionsManager'
import DonationManager from './pages/admin/DonationManager'

import './App.css'

function App() {
  return (
    <AuthProvider>
      <ContentProvider>
        <Router>
          <div className="App">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/programs" element={<ProgramsPage />} />
              <Route path="/programs/:id" element={<ProgramDetailPage />} />
              <Route path="/events" element={<EventsPage />} />
              <Route path="/board" element={<BoardPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:id" element={<BlogPostDetailPage />} />
              <Route path="/volunteer" element={<VolunteerPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/donate" element={<DonatePage />} />
              
              {/* Admin Routes */}
              {/* Unique login path so public users won't discover it */}
              <Route path="/admin/login-4f73b2c" element={<LoginPage />} />
              {/* Legacy alias so shared links work */}
              <Route path="/admin/login" element={<LoginPage />} />
              <Route path="/admin" element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } />
              <Route path="/admin/content" element={
                <ProtectedRoute>
                  <ContentManager />
                </ProtectedRoute>
              } />
              <Route path="/admin/board" element={
                <ProtectedRoute>
                  <BoardManager />
                </ProtectedRoute>
              } />
              <Route path="/admin/programs" element={
                <ProtectedRoute>
                  <ProgramManager />
                </ProtectedRoute>
              } />
              <Route path="/admin/events" element={
                <ProtectedRoute>
                  <EventManager />
                </ProtectedRoute>
              } />
              <Route path="/admin/blog" element={
                <ProtectedRoute>
                  <BlogManager />
                </ProtectedRoute>
              } />
              <Route path="/admin/volunteers" element={
                <ProtectedRoute>
                  <VolunteerApplicationsManager />
                </ProtectedRoute>
              } />
              <Route path="/admin/contact" element={
                <ProtectedRoute>
                  <ContactSubmissionsManager />
                </ProtectedRoute>
              } />
              <Route path="/admin/donation" element={
                <ProtectedRoute>
                  <DonationManager />
                </ProtectedRoute>
              } />
            </Routes>
          </div>
        </Router>
      </ContentProvider>
    </AuthProvider>
  )
}

export default App
